/**
 *  EDAP events
 */

const actionlocation = 'property-types-module';

export const PROPERTY_TYPES_LINK_CLICK = ({ propertyTypeKey }) => ({
  name: 'search.link.click',
  data: {
    actionlocation,
    eventrefinements: `filter:${propertyTypeKey}`
  }
});

export const PROPERTY_TYPES_CLICK_PREV = {
  name: 'nav.prev.click',
  data: {
    actionlocation
  }
};

export const PROPERTY_TYPES_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};
